<template>
  <li :class="styleClass.styleMain">
    <!-- 第一&第三個圓形 -->
    <template v-if="stepOne || stepThree">
      <p>{{ description }}</p>
    </template>
    <!-- 第二個圓形 -->
    <template v-else-if="stepTwo">
      <!-- 如是display + console -->
      <template v-if="hmiDisplayConsole">
        <p>{{ description }}</p>
        <p>
          {{ displayConsoleText.panel }}
          <span :class="{'success':(displayConsoleText.panelResult === 'passed')}">{{ displayConsoleText.panelResult}}</span>
        </p>
        <p>
          {{ displayConsoleText.up }}
          <span :class="{'success':(displayConsoleText.upResult === 'passed')}">{{ displayConsoleText.upResult}}</span>
        </p>
        <p>
          {{ displayConsoleText.down }}
          <span :class="{'success':(displayConsoleText.downResult === 'passed')}">{{ displayConsoleText.downResult}}</span>
        </p>
        <p>
          {{ displayConsoleText.power }}
          <span :class="{'success':(displayConsoleText.powerResult === 'passed')}">{{ displayConsoleText.powerResult}}</span>
        </p>
      </template>

      <p v-else-if="!time">
        {{ description }}
        <span :class="styleClass.styleStatus">{{ status }}</span>
        <ul class = "list-unstyled" v-if="styleClass.styleStatus"><li>{{batteryRlt}}</li></ul>
        <ul v-if="styleClass.styleStatus.error && componentName==='DiagnosisMotorBatteryStep'"><li>{{$t('diagnosis.msg.makeSureConnect')}}</li><li>{{$t('diagnosis.msg.tryRestart')}}</li></ul>

        <ul v-if="styleClass.styleStatus.error && componentName==='DiagnosisSensorStep' && bikeErrorCode < 200"><li>{{$t('diagnosis.msg.makeSureConnect')}}</li><li>{{$t('diagnosis.msg.tryRestart')}}</li></ul>
      </p>
      <p v-else-if="second">{{ strSlice }} <span>{{ second }} {{ $t('diagnosis.second') }}</span></p>
      <p v-else>{{ percent }} {{ description }}</p>
    </template>
  </li>
</template>
<script>
export default {
  name: 'diagnosisStep',
  props: [
    'componentName',
    'batteryRlt',
    'hmiDisplayConsole',
    'title',
    'description',
    'step',
    'time',
    'styleClass',
    'second',
    'percent',
    'status',
    'displayConsoleText',
    'strSlice',
    'bikeErrorCode'
  ],
  computed: {
    stepOne () {
      return this.step === 'one';
    },
    stepTwo () {
      return this.step === 'two';
    },
    stepThree () {
      return this.step === 'three';
    }
  }
};
</script>
